/**
 * name-cell.js
 */

import React from 'react';
import { Typography, Tooltip, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link as RouterLink } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import { makeLocation } from 'utils/routing';
import { getFilterParamsString } from 'utils/filter-params';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    marginRight: theme.spacing(1),
    '& > *': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    '& .name': {
      lineHeight: '16px'
    },
    '& .small': {
      fontSize: theme.typography.sizes[0],
      lineHeight: '12px',
      color: theme.palette.sys.onSurfaceVariant,
    }
  },
}));


export default function NameCell(props) {
  const {
    id,
    name,
    department,
    supervisors
  } = props;
  const classes = useStyles();
  const { user } = React.useContext(UserContext);

  // name params
  const nameLinkParams = id ? getFilterParamsString({ handlers: [id] }) : null;
  const nameLink = id ? makeLocation('', 'records', 'basic', { filterParams: nameLinkParams }) : null;

  // supervisor params
  const numSupervisorsMore = (supervisors?.length || 0) - 1;
  const supervisorsTooltip = (supervisors?.length || 0) > 1
    ? (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {supervisors.map(s => <span key={s.id}>{s.name}</span>)}
      </div>
    )
    : '';


  return <>
    <div className={classes.root}>

      {/* NAME */}
      <Typography variant='subtitle2' className='name'>
        {nameLink
          ? <Tooltip arrow placement='top' title={`View ${id === user.id ? 'My' : `${name}'s`} Records`}>
            <Link
              component={RouterLink}
              to={nameLink.pathname}
              children={id === user.id ? 'Me' : name}
              underline="hover" />
          </Tooltip>
        : name}
      </Typography>

      {/* DEPARTMENT */}
      <Typography variant='caption' className='small'>{department}</Typography>

      {/* SUPERVISOR(S) */}
      {supervisors &&
      <Typography variant='caption' className='small'>
        <Tooltip arrow placement='top' title={supervisorsTooltip}>
          <span>{supervisors?.[0].name}
          {numSupervisorsMore > 0 ? ` + ${numSupervisorsMore} More` : ''}</span>
        </Tooltip>
      </Typography>}

    </div>
  </>;
}